/** @jsxImportSource @emotion/react */
import React, { PropsWithChildren, forwardRef } from 'react';
import useStyle from './NavDrawer.style';

export type NavDrawerProps = PropsWithChildren<{}> & {
  name?: string;
  active?: boolean;
  withDefaultStyle?: boolean;
  Component: React.FC<any>;
};
const NavDrawer = forwardRef<HTMLDivElement, NavDrawerProps>(
  (
    { children, active = false, withDefaultStyle = false, Component, ...props },
    forwardRef
  ) => {
    const s = useStyle();

    return (
      <div
        ref={forwardRef}
        css={[s.container, active ? s.active : '']}
        {...props}
      >
        <div css={[s.wrapper, withDefaultStyle ? s.defaultWrapperStyle : '']}>
          <Component />
        </div>
      </div>
    );
  }
);

export default NavDrawer;
